import { z } from 'zod';

export const idArray = z.array(z.number().int());

export const reportTimezoneSchema = z
	.string()
	.trim()
	.min(1)
	.refine((timezone) => {
		try {
			new Intl.DateTimeFormat('en-US', { timeZone: timezone });
			return true;
		} catch {
			return false;
		}
	}, 'Invalid timezone');

export const transactionDateOrder = z.object({
	dateOrder: z.literal('transactionDate'),
	transactionStartDate: z.iso.date(),
	transactionEndDate: z.iso.date().optional(),
	applicationStartDate: z.iso.date().optional(),
	applicationEndDate: z.iso.date().optional(),
});

export const applicationDateOrder = z.object({
	dateOrder: z.literal('applicationDate'),
	applicationStartDate: z.iso.date(),
	applicationEndDate: z.iso.date().optional(),
	transactionStartDate: z.iso.date().optional(),
	transactionEndDate: z.iso.date().optional(),
});

export const paymentReportsFilterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string(),
	}),
]);

export const subscriberTypeSchema = z.enum(['All', 'Business', 'Individual']);

export type SubscriberType = z.infer<typeof subscriberTypeSchema>;

export const accountFilterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string(),
	}),
]);
